import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../../../style/colors';
import { MOBILE_BREAKPOINT, flexCenter, baseButton } from '../Header.style';

export const UserSection = styled.div`
  position: relative;

  @media (max-width: ${MOBILE_BREAKPOINT}) { display: none; }
`;

export const UserButton = styled.button`
  ${flexCenter}
  background: ${white};
  border: 1px solid ${neutral[200]};
  color: ${neutral[900]};
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  gap: 10px;
  transition: all 0.2s ease;

  &:hover {
    background: ${neutral[50]};
    border-color: ${neutral[300]};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  i {
    font-size: 18px;
    color: ${neutral[500]};
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: ${white};
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  min-width: 240px;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0) scale(1)' : 'translateY(-10px) scale(0.95)')};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  border: 1px solid ${neutral[200]};
`;

export const DropdownHeader = styled.div`
  ${flexCenter}
  background: linear-gradient(135deg, ${neutral[50]} 0%, ${white} 100%);
  color: ${neutral[900]};
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 2px solid ${primary[500]};
  gap: 10px;

  i {
    font-size: 18px;
    color: ${primary[500]};
  }
`;

export const DropdownInfo = styled.div`
  ${flexCenter}
  padding: 10px 16px;
  font-size: 12px;
  color: ${neutral[500]};
  border-bottom: 1px solid ${neutral[200]};
  gap: 10px;

  i {
    font-size: 16px;
    width: 18px;
    color: ${primary[500]};
  }
`;

export const DropdownItem = styled.button`
  ${baseButton}
  ${flexCenter}
  width: 100%;
  border-left: 3px solid transparent;
  padding: 12px 16px;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: ${neutral[700]};
  gap: 12px;

  &:hover {
    background: ${rgba(primary[500], 0.05)};
    border-left-color: ${primary[500]};
    color: ${neutral[900]};

    i {
      color: ${primary[500]};
      transform: scale(1.1);
    }
  }

  i {
    font-size: 20px;
    width: 22px;
    color: ${neutral[500]};
    transition: all 0.2s ease;
  }
`;
